import React from 'react'
import Float from '../../../../styles/float/Float'
import Outer from '../../../../styles/outer/Outer'
import ContactContent01 from '../../../../assets/bg/pc/bg_contact_content_01.png'
import ContactBG from '../../../../assets/bg/pc/bg_contact.png'
import FooterTitle from '../../../../assets/bg/pc/bg_footer_title.png'
import { View, Text } from '../../../../styles'
import styled from 'styled-components'

const ContactPCComponent = () => {
  const moveToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' })

  return (
    <Wrap>
      <Outer>
        <div style={{ marginTop: 195 }}>
          {/* height: 1832 */}
          <img src={ContactBG} />
        </div>
        <Float zIndex={false} style={{ marginTop: -195, zIndex: 100 }} left={'16.3%'} w={'67.59%'}>
          <img src={ContactContent01} />
          <MailList>
            <div className='col'>
              <a href='mailto:information@stocombine.io'>information@stocombine.io</a>
              <a href='mailto:business_development@stocombine.io'>business_development@stocombine.io</a>
            </div>
            <div className='col right'>
              <a href='mailto:press_marketing@stocombine.io'>press_marketing@stocombine.io</a>
              <a href='mailto:investment@stocombine.io'>investment@stocombine.io</a>
            </div>
          </MailList>
        </Float>

        {/* Footer */}
        <Float top={'50%'} left={'16.3%'} w={'48%'}>
          <img src={FooterTitle} />
        </Float>
        <Float float top={'50%'} left={'auto'} right={'17%'}>
          <View spacing={22} className={'bottom-menu'} direction='column'>
            <a href='#mverse'>
              <Text size='lg'>M-Verse</Text>
            </a>
            <a href='#overview'>
              <Text size='lg'>Overview</Text>
            </a>
            <a href='#ecosystem'>
              <Text size='lg'>Ecosystem</Text>
            </a>
            <a href='#service'>
              <Text size='lg'>Service</Text>
            </a>
            <a href='#download'>
              <Text size='lg'>Download</Text>
            </a>
            <a href='#team'>
              <Text size='lg'>Team</Text>
            </a>
            <a href='#contact'>
              <Text size='lg'>Contact us</Text>
            </a>
          </View>
        </Float>

        <Footer>
          <View block justify='space-between' align='flex-end'>
            <View direction='column' spacing={20}>
              <View className='info' direction='column' color='#fff' spacing={4}>
                <Text>| M-Verse Co. Ltd</Text>
                <Text>| CEO Stuart S. Lee / Seongsik Kim</Text>
                <Text>| Address: #417, 41, Sangnok-ro 16-gil, Suseong-gu, Daegu, Republic of Korea</Text>
                <Text>| Business registration number: 111–81-35619</Text>
              </View>
              <Text size='md' color='white-color'>
                © 2023, <Text weight='bold'>M-Verse</Text>.Co.Ltd
              </Text>
            </View>
            <Text color='white-color' onClick={moveToTop} style={{ cursor: 'pointer' }}>
              Back to top
            </Text>
          </View>
        </Footer>
      </Outer>
    </Wrap>
  )
}

export default ContactPCComponent

const Wrap = styled.div`
  .bottom-menu {
    & > a {
      color: #fff;
      &:hover {
        color: #4d5876;
      }
    }
  }
`

const Footer = styled.div`
  position: absolute;
  bottom: 5%;
  left: 0;
  right: 0;
  margin: 0 16.3%;
  border-top: 0.1px solid #d8d8d8;
  padding-top: 4%;
  z-index: 99;

  .info {
    & > div {
      font-size: 16px;
      color: #fff !important;
    }
  }
`

const MailList = styled.div`
  display: flex;
  position: absolute;
  width: 100%;
  height: 25%;
  top: 58.7%;
  left: 0;

  .col {
    flex: 1;
    max-width: 47%;

    &.right {
      & > a {
        padding-left: 14%;
      }
    }

    & > a {
      display: block;
      padding-top: 3.2%;
      padding-left: 23%;
      line-height: 1;
      font-size: 1.2vw !important;

      & + a {
        margin-top: 3.3%;
      }
    }
  }
`
